(function () {
  function initRotator(root) {
    var slides = root.querySelectorAll('.image-with-text__rotate-slide');
    if (slides.length < 2) return;
    var interval = parseInt(root.getAttribute('data-rotate-interval'), 10) || 5000;
    var current = 0;
    setInterval(function () {
      slides[current].classList.remove('is-active');
      slides[current].style.opacity = 0;
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].style.opacity = 1;
    }, interval);
  }

  document.querySelectorAll('[data-rotate-images]').forEach(initRotator);
})();
